import Sider from "antd/es/layout/Sider";

const FactoryGuideSider = () => (
    <Sider
        width={300}
        style={{
            backgroundColor: "#ffffff",
            height: "calc(100vh - 100px)",
            position: "sticky",
            top: 64,
            overflowY: "auto",
        }}
    >
        <div
            style={{
                height: "64px",
                padding: "16px",
                fontSize: "16px",
                fontWeight: "bold",
                backgroundColor: "var(--color-primary)",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                color: "white",
            }}
        >
            Guía de Fábrica de Agentes
        </div>
        <p style={{ padding: "16px" }}>En Construcción.</p>
        <p style={{ padding: "16px" }}>Más opciones...</p>
    </Sider>
);

export default FactoryGuideSider;